import React from "react";

import makeStyles from "@mui/styles/makeStyles";
import Container from "@mui/material/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		padding: theme.spacing(2.5, 3),
		height: `calc(100% - 56px)`,
		maxWidth: "100% !important",
	},

	contentWrapper: {
		height: "100%",
		overflowY: "hidden",
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(2),
	},
}));

const MainContainer = ({ children }) => {
	const classes = useStyles();

	return (
		<Container className={classes.mainContainer}>
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
